var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import React, { Suspense } from 'react';
import { action, makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import { Apphandler } from '@/ipc/MainAppHandler';
import { ScaleLoader } from 'react-spinners';
import { FloatingPdfPageStore } from '@/app/UIComponents/PdfPagestore';
const FloatingViewerComponent = React.lazy(() => import('@/app/admin/UIComponents/AdminFloatingPdfViewer'));
class State {
    constructor() {
        this.show = false;
        this.activefileid = "";
        this.activefilekey = "";
        this.ref = null;
        this.pagedetails = [];
        this.activepagenumber = 0;
        this.activeuserid = "";
        this.activeletrid = "";
        makeObservable(this);
    }
    setPdfPageDetails(details) {
        this.pagedetails = details;
        details.forEach((det) => {
            if (det.words !== undefined && det.words.length > 0) {
                FloatingPdfPageStore.pages.set(det.filename + "-words", JSON.stringify(det.words));
            }
        });
    }
    setActiveUserId(userid) {
        this.activeuserid = userid;
    }
    setActiveLetrId(userid) {
        this.activeletrid = userid;
    }
    setActiveFileKey(key) {
        this.activefilekey = key;
    }
    setActiveFileId(fid) {
        this.activefileid = fid;
    }
    reset() {
        this.setShow(false);
        this.setActiveFileId("");
    }
    getPdfInfo() {
        const req = {
            id: this.activefileid,
            accesskey: this.activefilekey
        };
        Apphandler.sendMessage("pdffilemeta", req);
    }
    getPdfPage(pagenumber) {
        this.loadPdfPage(pagenumber);
    }
    loadPdfPage(page) {
        if (this.pagedetails.length < page) {
            return;
        }
        const deet = this.pagedetails[page];
        const req = {
            id: this.activefileid,
            pagename: deet.filename,
            pagenumber: page,
            accesskey: this.activefilekey,
            ischooser: true,
            userid: this.activeuserid
        };
        Apphandler.sendMessage("adminpdfpage", req);
        if (!FloatingPdfPageStore.pages.has(deet.filename + "-words")) {
            const req = {
                id: this.activefileid,
                pagename: deet.filename + "-words",
                pagenumber: page,
                accesskey: this.activefilekey,
                ischooser: true,
                userid: this.activeuserid
            };
            deet.wordloaded = true;
            Apphandler.sendMessage("adminpdfpage", req);
        }
    }
    getPdfPageDetail(num) {
        if (this.pagedetails.length > num) {
            return this.pagedetails[num];
        }
        return undefined;
    }
    clear() {
        this.pagedetails = [];
    }
    setShow(show) {
        var _a;
        this.show = show;
        if (!this.show) {
            (_a = this.onclosecb) === null || _a === void 0 ? void 0 : _a.call(this);
        }
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], State.prototype, "show", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], State.prototype, "activefileid", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], State.prototype, "setPdfPageDetails", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], State.prototype, "setActiveFileId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], State.prototype, "reset", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], State.prototype, "clear", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], State.prototype, "setShow", null);
export const AdminFloatingPdfConatinerState = new State();
let AdminFloatingPdfConatiner = class AdminFloatingPdfConatiner extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return React.createElement(Suspense, { fallback: React.createElement(ScaleLoader, { color: 'green' }) },
            React.createElement(FloatingViewerComponent, { viewerheight: this.props.viewerheight, getPageDetail: (num) => AdminFloatingPdfConatinerState.getPdfPageDetail(num), onClose: () => AdminFloatingPdfConatinerState.setShow(false), totalpages: AdminFloatingPdfConatinerState.pagedetails.length, getPage: (page) => AdminFloatingPdfConatinerState.getPdfPage(page) }));
    }
};
AdminFloatingPdfConatiner = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], AdminFloatingPdfConatiner);
export { AdminFloatingPdfConatiner };
